import { useNavigate } from "react-router-dom";
import { Building2, Plus } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const CompanySwitcher = () => {
  const { companies, companyId, setCompanyId } = useCompany();
  const navigate = useNavigate();

  if (!companies.length) {
    return (
      <button onClick={() => navigate("/parametres?new=1")} className="w-full flex items-center gap-2 text-sm text-brand-300 hover:text-white transition-colors" data-testid="company-switcher-create">
        <Plus className="h-4 w-4" /> Créer une entreprise
      </button>
    );
  }
  return (
    <Select value={companyId} onValueChange={(v) => (v === "__new" ? navigate("/parametres?new=1") : setCompanyId(v))}>
      <SelectTrigger className="bg-ink-light border-ink-border text-white h-10 focus:ring-brand-400" data-testid="company-switcher-trigger">
        <div className="flex items-center gap-2 truncate"><Building2 className="h-4 w-4 text-brand-300 shrink-0" /><SelectValue /></div>
      </SelectTrigger>
      <SelectContent>
        {companies.map((c) => (
          <SelectItem key={c.id} value={c.id} data-testid="company-switcher-option">{c.name}</SelectItem>
        ))}
        <SelectItem value="__new" data-testid="company-switcher-new">+ Nouvelle entreprise</SelectItem>
      </SelectContent>
    </Select>
  );
};
